export const MEDIO_PAGO = {
	EFECTIVO: 20,
	TARJETA_DEBITO: 21,
	TARJETA_CREDITO: 22,
	CHEQUE: 23,
	TRANSFERENCIA: 24,
	QR: 25,
}